import { render, staticRenderFns } from "./contactsSettings.vue?vue&type=template&id=7819e1e6&"
import script from "./contactsSettings.vue?vue&type=script&lang=js&"
export * from "./contactsSettings.vue?vue&type=script&lang=js&"
import style0 from "./contactsSettings.vue?vue&type=style&index=0&tyle=text%2Fcss&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCheckbox,VRadio,VRadioGroup,VTextField,VTooltip})
